import { configureStore } from '@reduxjs/toolkit';
import reducer from './authSlice';

const store = configureStore({
  reducer: {
// @ts-ignore
    auth: reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
